import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '../environment.service';
import { AuthService } from '../services/auth.service';
import { CompanyService } from '../services/company.service';
import { LocalStorageService } from '../services/localstorage.service';
import { PromptForDefaultStoreDialogComponent } from './prompt-for-default-store-dialog/prompt-for-default-store-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CrmUpboardService } from '../crm/crm-upboard/crm-upboard.service';
import { CrmUpboardPerson } from '../crm/crm-upboard/interfaces/crm-upboard-person.interface';
import { UpboardStatusTypes } from '../constants/upboard-status-types';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  // form states
  formProcessing = false;
  reveal = false;
  sessionExpired = false;

  // form model
  model = {
    username: null,
    password: null
  };

  // messages
  formError: string;

  constructor(
    private _authSvc: AuthService,
    private _companySvc: CompanyService,
    private _envSvc: EnvironmentService,
    private _lsSvc: LocalStorageService,
    private _router: Router,
    private _crmUpboardService: CrmUpboardService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {

    const sessionExpired = this._lsSvc.getItem('sessionExpired');
    if (sessionExpired) {
      this.sessionExpired = true;
      this._lsSvc.removeItem('sessionExpired');
    }

    // if user is logged in and has claims redirect to dashboard
    if (this._authSvc.isLoggedIn()) {
      this._router.navigate(['/dashboard']);
      return;
    } else {
      this._authSvc.clearData();
    }

    this.reveal = true;

    document.body.classList.add('login');

  }

  ngOnDestroy() {
    document.body.classList.remove('login');
  }

  /**
   * Get user's claims
   */
  private getClaims(): void {

    var returnRoute = '/dashboard';

    this._authSvc.getUserClaims()
      .subscribe((res: any) => {
        if (document.location.href.includes("ReturnUrl")) {
          var returnQueryStringRoute = document.location.href.split("?ReturnUrl=")[1];
          if (returnQueryStringRoute) {
            let decodedReturnSavedRoute = decodeURIComponent(returnQueryStringRoute);
            if (returnQueryStringRoute.length && decodedReturnSavedRoute.length > 0) {
              returnRoute = decodedReturnSavedRoute;
            }
          }
        }

        this.checkCheckedIn();

        this._companySvc.updateCompanySystemConfig();

        if(res.PromptForDefaultStore) {
          const dialogRef = this.dialog.open(PromptForDefaultStoreDialogComponent, {
            autoFocus: false,
            disableClose: true,
            position: {top: '60px'},
            minWidth: '400px',
            maxWidth: '400px',
            width: '99%'
          });
      
          dialogRef.afterClosed().subscribe((result) => {
            if (result.confirm) {
              //get and update user data
              let userData = this._lsSvc.getItem('user');
              userData['storeRefId'] = result.storeRefId;
              userData['defaultPriceTypeId'] = result.defaultPriceTypeId;
              this._lsSvc.setItem('user', userData);

              this._router.navigate([returnRoute]);
            }
          });
        }
        else{
          this._router.navigate([returnRoute]);
        }

        
       
      }, () => {
        this._authSvc.clearData();
        this.formError = 'There was a problem signing in. Please try again shortly.';
        this.formProcessing = false;
      });

  }

  /**
   * Login form submit event handler
   * @param e - event
   */
  onSubmit(e: any, form: object): void {

    e.preventDefault();

    // if form is invalid, return
    if (!form['valid'] || this.formProcessing) {
      return;
    }

    // clear errors
    this.formError = undefined;

    // set form to processing to prevent double submissions and show spinner
    this.formProcessing = true;

    // log the user in
    this._authSvc.login(this.model)
      .subscribe((res: any) => {

        if (res && res.success) {
          this.getClaims();

          let env = this._envSvc.getEnvironment();

          if (env !== 'Production') {

            let storedShowEnv = this._lsSvc.getItem('showEnv');

            if (storedShowEnv || storedShowEnv === null) {
              this._envSvc.showEnv();
            }
            else {
              this._envSvc.hideEnv();
            }
          }

        } else {
          this.formError = 'Invalid username/password combination.';
          this.formProcessing = false;
        }

      },
        (err: any) => {

          this.formProcessing = false;

          if (err && err.error && err.error['error'] === 'invalid_grant') {
            this.formError = 'Invalid username/password provided';
          } else if (err && err.error && err.error['error'] === 'max_users' && err.error['error_description']) {
            this.formError = err.error['error_description'];
          } else {
            this.formError = 'There was a problem signing in. Please try again shortly.';
          }

        }
      );
  }

  checkCheckedIn() {
    // get sales person id from local storage
    let user = this._lsSvc.getItem('user');
    let salesPersonId = user['spid'];
    let storeRefId = this._lsSvc.getItem('user')['storeRefId']

    

    if (!salesPersonId) {
      return;
    }
    else {
      // check if they are checked in to the server
      this._crmUpboardService.getUpboardPersonBySalesPersonIdAndStore(salesPersonId, storeRefId).subscribe((res: any) => {
        let upboardPerson: CrmUpboardPerson = res?.Result;
          if (upboardPerson && upboardPerson.UpboardStatus !== UpboardStatusTypes.CheckedOut) {
            this._crmUpboardService.setUpboardPersonId(upboardPerson.Id);
            this._crmUpboardService.startFetchingUpNext();
          }
      });
    }
  }
}
